import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProblemSolution() {
  return <section className="py-20 md:py-28 bg-warm-white px-6" data-id="element-156">
      <div className="max-w-[1100px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-157">
        {/* Left Column */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-158">
          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-6" data-id="element-159">
            The Missing Piece in Your Retirement Strategy?
          </h2>
          <div className="space-y-6 text-charcoal text-lg leading-relaxed" data-id="element-160">
            <p data-id="element-161">
              Most people overpay in taxes during retirement. An IUL insurance
              policy provides a powerful alternative to traditional retirement
              accounts with no contribution limits and tax-free access to your
              money when structured correctly.
            </p>
            <p data-id="element-162">
              Xander shows you how IUL can complement your 401(k), IRA, or
              brokerage accounts so you're not relying solely on fully taxable
              income streams in your golden years.
            </p>
          </div>
        </motion.div>

        {/* Right Column - Checklist Card */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-cream rounded-2xl p-8 md:p-10 border border-gray-100 shadow-soft" data-id="element-163">
          <span className="text-copper font-bold text-xs tracking-wider uppercase mb-6 block" data-id="element-164">
            Common Retirement Concerns
          </span>

          <ul className="space-y-4 mb-8" data-id="element-165">
            {['Worried about how much of your nest egg the IRS will take in retirement', 'Limited by contribution caps in 401(k)s, IRAs, or Roth accounts', 'Looking for additional tax-free income sources beyond Social Security', 'Wanting market participation without exposing your principal to losses'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-166">
                <CheckCircle2 className="text-copper mt-1 shrink-0" size={20} data-id="element-167" />
                <span className="text-charcoal font-medium" data-id="element-168">{item}</span>
              </li>)}
          </ul>

          <p className="text-sage text-sm italic border-t border-gray-200/60 pt-4" data-id="element-169">
            IUL isn't right for everyone. But for the right profile, it can
            serve as a cornerstone of a more tax-efficient retirement strategy.
          </p>
        </motion.div>
      </div>
    </section>;
}